// Ionic Angular
import { Component, ViewEncapsulation } from '@angular/core'


@Component({
    selector: 'tidy-select-small',
    styleUrls: ['./tidy-select-small.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="tidy-container">
          <div class="tidy-item tidy-select-small--ico">
            <ng-content select="[item-icon-left]"></ng-content>
          </div>
          <div class="tidy-item">
            <ng-content select="[item-select-left]"></ng-content>
          </div>
          <div class="tidy-item tidy-select-small--small-text">
             <ng-content select="[item-select-middle]"></ng-content>
          </div>
          <div class="tidy-item tidy-select-small--ico">
            <ng-content select="[item-icon-right]"></ng-content>
          </div>
          <div class="tidy-item">
            <ng-content select="[item-select-right]"></ng-content>
          </div>
        </div>
      `,
    standalone: false
})
export class TidySelectSmall {}
